import React from "react";

export const LNG = [
  <>
    <h4 className="slideTitle">
      Shell mosaic of new fuels moving towards CO<sub>2</sub> neutrality
    </h4>
    <div className="slideContainer slide_solidColour">
      <p>
        Fleet projected to reach 400 million vehicles worldwide by 2050
        (including 80 million HDVs){" "}
      </p>
    </div>
    <p>
      <img src="images/LNGmosaic.JPG" width="100%" height="auto" />
    </p>
  </>,
  <div className="slideContainer slide_solidColour">
    <div className="colLeft col40">
      <h4 className="slideTitle">Why LNG</h4>
      <p>LNG provides a range of benefits</p>
      <ul className="shell_bullets_list">
        <li>
          Low TCO providing high CO<sub>2</sub> savings and competitive to
          Bio-diesel.
        </li>
        <li>
          Pan-EU Network, LNG sites located along all key corridors, and part of
          eS invoice.
        </li>
        <li>Range up to 1.600 km.</li>
        <li>Driver Acceptance - less noise with same power.</li>
        <li>HSSE – safe and easy refueling process.</li>
      </ul>
    </div>
    <div className="colRight col60">
      <img
        alt=""
        class="mr-3"
        src="images/LNGWhy.JPG"
        width="100%"
        height="auto"
      />
    </div>
  </div>,
  <div className="slideContainer slide_solidColour noGutters">
    <div className="colLeft col50 solidColourContainer">
      <h4 className="slideTitle">Where des Bio-LNG come from?</h4>
      <p>Bio-LNG is created from Biomethane.</p>
      <ul className="shell_bullets_list">
        <li>
          Biomethane is a bespoke product and Shell can tailor a solution which
          works specifically for your business needs.
        </li>
        <li>
          Biomethane is a solution which can achieve up to 100% decarbonization,
          helping you meet your carbon reduction goals today.
        </li>
        <li>Biomethane is available today and solutions are available now. </li>
      </ul>
      {/* <img
        src="images/LNGbio2.png"
        width="100%"
        height="auto"
      /> */}
    </div>
    <div className="colRight col50">
      <img src="images/LNGbio2.png" width="100%" height="auto" />
    </div>
  </div>,
  <div className="slideContainer slide_solidColour">
    <div className="colLeft col50">
      <h4 className="slideTitle">Gas-To-Liquid (GTL)</h4>
      <p>
        <strong>
          GTL fuel is a cleaner, safer alternative to diesel that works without
          the need for engine modifications
        </strong>
      </p>
      <ul className="shell_bullets_list">
        <li>Shell began developing GTL technology in the 1970s</li>
        <li>
          We opened the world’s first commercial GTL plant in Bintulu, Malaysia
          in 1993 and the world’s largest GTL plant, Pearl GTL, in Qatar in 2011
        </li>
        <li>
          Already being used in public buses, city utility vehicles and
          heavy-duty trucks in Europe
        </li>
        <li>
          Contains none of the impurities – sulphur, aromatics and nitrogen –
          that are in crude oil
        </li>
      </ul>
      <p className="mt-5">
        <sup>
          *Ranges are used to account for the fact that benefits may vary from
          engines of different sizes, powers, manufacturers etc. This range is
          not exact: It represents the maximum variation in results observed in
          scientific experiments which compared emissions from Shell GTL Fuel
          with conventional diesel. These trials were conducted by both Shell
          laboratories and a variety of independent organisations: On-road data
          was gathered both from Shell in-house laboratories and in partnership
          with independent test partners including AVL, TNO, Millbrook UK, NREL
          USA, among others.
        </sup>
      </p>
    </div>
    <div className="colRight col50 solidColourContainer">
      <h4 className="slideTitle">Did you know</h4>
      <ul className="shell_bullets_list icons_list">
        <li className="mb-4">
          <img
            src="images/chevron.png"
            width="auto"
            height="50px"
            alt=""
            className="align-self-start"
          />
          <span>
            <strong className="fontx2 mb-3 d-block">$1bn</strong>We have
            invested more than $1bn and filed over 3,500 patents in developing
            the GTL process
          </span>
        </li>
        <li className="mb-4">
          <img
            src="images/chevron-down.png"
            width="auto"
            height="50px"
            alt=""
            className="align-self-start"
          />
          <span>
            <strong className="fontx2 mb-3 d-block">5-37%</strong>Nitrogen oxide
            reduction range*
          </span>
        </li>
        <li className="mb-4">
          <img
            src="images/chevron-down.png"
            width="auto"
            height="50px"
            alt=""
            className="align-self-start"
          />
          <span>
            <strong className="fontx2 mb-3 d-block">10-38%</strong>Particulate
            matter reduction range*
          </span>
        </li>
      </ul>
    </div>
  </div>,
];
